import React, { useEffect, useMemo, useState } from 'react'
import BillingService from '../../../services/billing/BillingService'
import Card from '../../../components/Card'
import DataTable from 'react-data-table-component'
import { Spinner } from 'react-bootstrap'
import { formatDateTimeLocalDate } from '../../../utilities/Utils'

const ExpandableComponentBilling = ({ data }) => {

    let billingService = useMemo(() => new BillingService(), [])
    const [listDetail, setListDetail] = useState([])
    const [dataPayment, setDataPayment] = useState(null)
    const [namaBank, setNamaBank] = useState(null)
    const [namaChannel, setNamaChannel] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const fetchDetail = async () => {
            setLoading(true)
            try {
                const response = await billingService.listBillingDetailByIdTrxUpt(data.idTrxUpt)
                setListDetail(response.data.data)

                if (data.flagTransaction === '1') {
                    const resPayment = await billingService.listPayment(data.noBill)
                    setDataPayment(resPayment.data)

                    const resBank = await billingService.getBankById(resPayment.data.bankId)
                    setNamaBank(resBank.data.bankName)

                    const resChannel = await billingService.getChannelById(resPayment.data.cnlId)
                    setNamaChannel(resChannel.data.channelName)
                }
            } catch (error) {
                setListDetail([])
            }
            setLoading(false)
        }
        fetchDetail()
    }, [billingService, data])

    const columns = [
        {
            name: 'Nomor Aju',
            cell: row => row['nomorAju']
        },
        {
            name: 'Nomor PNBP',
            cell: row => row['nomorPnbp']
        },
        {
            name: 'Nominal',
            cell: row => row['nominal']
        },
        {
            name: 'Volume',
            cell: row => row['volume']
        },
        {
            name: 'Satuan',
            cell: row => row['satuan']
        }
    ]

    return (
        <>
            <Card>
                <Card.Body>
                    <div className="header-title">
                        <h4 className="card-title">Detail Billing</h4>
                    </div>
                    <div className="table-responsive border-bottom my-3">
                        {(loading && <Spinner />)}
                        <DataTable
                            customStyles={{ headCells: { style: { 'background-color': '#7c878dff', 'color': 'white' } } }}
                            columns={columns}
                            data={listDetail}
                            highlightOnHover
                            pagination
                        />
                    </div>
                    {
                        dataPayment &&
                        <>
                            <div className="header-title">
                                <h4 className="card-title">Detail Pembayaran</h4>
                            </div>
                            <div className='row mb-3'>
                                <div className="col-sm-4">
                                    <label className="col-sm-4 col-form-label-sm">NTB</label>
                                    <input type="text" className="col-sm-8 form-control-sm" name="ntb" value={dataPayment.ntb} disabled />
                                </div>
                                <div className='col-sm-4'>
                                    <label className="col-sm-4 col-form-label-sm">NTPN</label>
                                    <input type="text" className="col-sm-8 form-control-sm" name="ntpn" value={dataPayment.ntpn} disabled />
                                </div>
                            </div>
                            <div className='row mb-3'>
                                <div className="col-sm-4">
                                    <label className="col-sm-4 col-form-label-sm">Tanggal Bayar</label>
                                    <input type="text" className="col-sm-8 form-control-sm" name="tglBayar" value={formatDateTimeLocalDate(dataPayment.datePayment)} disabled />
                                </div>
                                <div className='col-sm-4'>
                                    <label className="col-sm-4 col-form-label-sm">Tanggal Buku</label>
                                    <input type="text" className="col-sm-8 form-control-sm" name="tglBuku" value={formatDateTimeLocalDate(dataPayment.datePembukuan)} disabled />
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-sm-4">
                                    <label className="col-sm-4 col-form-label-sm">Bank Pembayaran</label>
                                    <input type="text" className="col-sm-8 form-control-sm" name="bank" value={namaBank ? namaBank : dataPayment.bankId} disabled />
                                </div>
                                <div className='col-sm-4'>
                                    <label className="col-sm-4 col-form-label-sm">Channel Pembayaran</label>
                                    <input type="text" className="col-sm-8 form-control-sm" name="channel" value={namaChannel ? namaChannel : dataPayment.cnlId} disabled />
                                </div>
                            </div>
                        </>
                    }
                </Card.Body>
            </Card>
        </>
    )
}

export default ExpandableComponentBilling